module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_honda_06.8aadab42.jpg";